import styled from 'styled-components';
import Button from 'antd/lib/button';

export const StyledButton = styled(Button)`
  position: relative;
  z-index: 1;
`;
